module.exports = __webpack_public_path__ + "img/camera.1e120c25.png";